import { transform } from "ol/proj";

const latlongArr = () => {
    let longlatArr = [latlongArr[1], latlongArr[0]];
    return transform(longlatArr, "EPSG:4326", "EPSG:3857");
};

export default latlongArr;